let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("baRsZ")).then(() => parcelRequire('jpYYq'));